import { c as _c } from "react/compiler-runtime";
import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import HotspotWrapper from './HotspotWrapper';
const HotspotWrapperRoot = t0 => {
  const $ = _c(27);
  let children;
  let className;
  let dontFadeTagIcon;
  let fromMobileGrid;
  let isActive;
  let props;
  let style;
  let t1;
  if ($[0] !== t0) {
    const {
      children: t2,
      className: t3,
      dontFadeTagIcon: t4,
      fromMobileGrid: t5,
      isActive: t6,
      isContentfulPromotionHero: t7,
      showOnActive,
      style: t8,
      ...t9
    } = t0;
    children = t2;
    className = t3;
    dontFadeTagIcon = t4;
    fromMobileGrid = t5;
    isActive = t6;
    t1 = t7;
    style = t8;
    props = t9;
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = dontFadeTagIcon;
    $[4] = fromMobileGrid;
    $[5] = isActive;
    $[6] = props;
    $[7] = style;
    $[8] = t1;
  } else {
    children = $[1];
    className = $[2];
    dontFadeTagIcon = $[3];
    fromMobileGrid = $[4];
    isActive = $[5];
    props = $[6];
    style = $[7];
    t1 = $[8];
  }
  const isContentfulPromotionHero = t1 === undefined ? false : t1;
  const [rootRef, setRootRef] = useState(null);
  const createRootRef = useRef(null);
  let t2;
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      if (createRootRef && createRootRef.current) {
        setRootRef(createRootRef.current);
      }
    };
    t3 = [createRootRef];
    $[9] = t2;
    $[10] = t3;
  } else {
    t2 = $[9];
    t3 = $[10];
  }
  useEffect(t2, t3);
  const t4 = !!className && !fromMobileGrid;
  const t5 = !fromMobileGrid && !isContentfulPromotionHero;
  const t6 = !fromMobileGrid && isContentfulPromotionHero;
  let t7;
  if ($[11] !== className || $[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t7 = classNames({
      [className]: t4,
      relative: t5,
      "static opacity-100 rounded-lg": t6
    });
    $[11] = className;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== dontFadeTagIcon || $[17] !== fromMobileGrid || $[18] !== isActive || $[19] !== props || $[20] !== rootRef) {
    t8 = <HotspotWrapper rootRef={rootRef} {...props} isActive={isActive} dontFadeTagIcon={dontFadeTagIcon} fromMobileGrid={fromMobileGrid} />;
    $[16] = dontFadeTagIcon;
    $[17] = fromMobileGrid;
    $[18] = isActive;
    $[19] = props;
    $[20] = rootRef;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== children || $[23] !== style || $[24] !== t7 || $[25] !== t8) {
    t9 = <div ref={createRootRef} className={t7} style={style}>{t8}{children}</div>;
    $[22] = children;
    $[23] = style;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
};
HotspotWrapperRoot.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  dontFadeTagIcon: PropTypes.bool,
  fromMobileGrid: PropTypes.bool,
  isActive: PropTypes.bool,
  isContentfulPromotionHero: PropTypes.bool,
  root: PropTypes.string,
  setHotspotData: PropTypes.func,
  showOnActive: PropTypes.bool,
  showTooltip: PropTypes.bool,
  src: PropTypes.string,
  style: PropTypes.string
};
export default HotspotWrapperRoot;